import {PageError403} from '@/pages/Errors/403'
import {PageError500} from '@/pages/Errors/500'
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'
import {ProtectedRoutes} from './ProtectedRoutes'
import {setShellActive, setShellPath} from '@/store/slices/commonSlice'
import {
  PageError404,
  OrderDetail,
  OnlineOrder,
  OrdersItemDetail,
  OfflineOrderDetail
} from '@/pages'
import {useAppDispatch} from '@/store'
import {useEffect} from 'react'
import {ImageOptimization} from '@/containers/ImageOptimization'
import { setCountryCode } from '@/store/slices/countryCodeSlice'
import { useGrowthBookFeatureFlags } from '@/hooks/use-growthbook-feature-flags-hook'
import { GrowthBookProvider } from '@growthbook/growthbook-react'


const orderRoutes = [
  {path: ROUTES.ORDER_DETAIL_PAGE, element: <OrderDetail />},
  {path: ROUTES.ORDER_LIST, element: <OnlineOrder />},
  {path: ROUTES.ORDERS_ITEM_DETAIL, element: <OrdersItemDetail />},
  {path: ROUTES.OFFLINE_ORDER_DETAIL_PAGE, element: <OfflineOrderDetail />},
]
const router = createBrowserRouter([
  {
    element: <ProtectedRoutes />,
    children: [
      {path: ROUTES.HOME, element: <OnlineOrder />},
      {path: ROUTES.IMAGE, element: <ImageOptimization />},

      /* Errors */
      {path: ROUTES.ERROR_500, element: <PageError500 />},
      {path: ROUTES.ERROR_403, element: <PageError403 />},
      {path: '*', element: <PageError404 />},

      /* Orders */
      ...orderRoutes,
    ],
  },
])

export const AppRouter = ({shellActive, darkTheme, path, market}) => {
  const dispatch = useAppDispatch()
  const {growthbook} = useGrowthBookFeatureFlags()

  useEffect(() => {
    dispatch(setShellActive(shellActive))
    if (market) {
      dispatch(setCountryCode(market))
    }
  }, [shellActive, dispatch, market])

  useEffect(() => {}, [darkTheme])

  // expected everytime to dispatch the shell path when component is mounted to navigate properly
  useEffect(() => {
    dispatch(setShellPath(path))
  })

  return (
    <GrowthBookProvider growthbook={growthbook}>
      <RouterProvider router={router} />
    </GrowthBookProvider>
  )
}
